import React from 'react';

import Link from './Link';
import Row from './Row';

type NodeMap = {
	[key: string]: React.ReactNode[];
};

const ABOUT_ME: NodeMap = {
	about: [
		<Row key="about-1">
			{'Born in Alaska, studied in California, and living in'}
		</Row>,
		<Row key="about-2">
			{'Dubai. Married to Joella. Trying to follow '}
			<Link href="https://www.esv.org/John+14:6/">Jesus</Link>
			{'.'}
		</Row>,
	],
	email: [
		<Row key="email">
			{'personal: '}
			<a href="mailto:evan.m.thibodeau@gmail.com">
				evan.m.thibodeau@gmail.com
			</a>
		</Row>,
	],
	github: [
		<Row key="github">
			<Link href="https://github.com/ethib137">ethib137</Link>
		</Row>,
	],
	linkedin: [
		<Row key="linkedin">
			<Link href="https://www.linkedin.com/in/evanthibodeau">https://www.linkedin.com/in/evanthibodeau</Link>
		</Row>,
	],
	location: [
		<Row key="location">
			<Link href="https://www.google.com/maps/place/Dubai">
				{'Dubai, UAE'}
			</Link>
		</Row>,
	],
	name: [<Row key="name">{'Evan Thibodeau'}</Row>],
	work: [
		<Row key="work">
			{'Customer Success Engineer @ '}
			<Link href="https://www.resend.com/">Resend</Link>
		</Row>,
	],
};

export default ABOUT_ME;
